// packages/services/src/orderService.ts
import { Order } from "@cabukaka/types"
import { dataService } from "./core/dataService"
import { QueryFilters } from '@cabukaka/types'
import axios from 'axios';
import { getConfig } from '@cabukaka/config';
import { mapMongoDocs } from "@cabukaka/utils/index";

export const orderService = {
    get baseService() {
        return dataService<Order>("orders");
    },

    getMyOrders: async (token?: string, page: number = 1, limit: number = 20): Promise<any> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get(`${apiUrl}/orders/client/my-orders`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
                params: { page, limit }
            });
            return {
                ...res.data,

                data: mapMongoDocs(res.data.data),
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },

    getMyShopOrders: async (token?: string, page: number = 1, limit: number = 20): Promise<any> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get(`${apiUrl}/orders/shop/my-orders`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
                params: { page, limit }
            });
            return {
                ...res.data,

                data: mapMongoDocs(res.data.data),
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },

    updateOrderStatus: async (id: string, status: string, token?: string): Promise<Order | null> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.put(`${apiUrl}/orders/${id}/status`, { status }, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    }
};